import { Select } from '@chakra-ui/react';

export enum ApplicationsStatusFilterEnum {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
}

const options = [
  {
    key: ApplicationsStatusFilterEnum.COMPLETED,
    label: 'Completed',
  },
  {
    key: ApplicationsStatusFilterEnum.PENDING,
    label: 'Pending',
  },
  {
    key: ApplicationsStatusFilterEnum.FAILED,
    label: 'Failed',
  },
];

const ApplicationsStatusFilter = ({ selectedStatus, setSelectedStatus }) => {
  return (
    <Select
      size="sm"
      placeholder="Any Status"
      value={selectedStatus}
      onChange={(e) => setSelectedStatus(e.target.value)}
    >
      {options.map((status) => (
        <option key={status.key} value={status.key}>
          {status.label}
        </option>
      ))}
    </Select>
  );
};

export default ApplicationsStatusFilter;
